import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <AboutSection />
        <ContactSection />
        <FaqSection />
        <TopicsSection />
        <CarouselSection />
        <UpdatesSection />
        <MediaSection />
        <RankingSection />
        <CardsSection />
        <IndexSection />
        <AppSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}